/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Faq_When_AInputs */

const en_directory_hubs_signals_faq_when_a = /** @type {(inputs: Directory_Hubs_Signals_Faq_When_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product pages currently show deterministic preview scores. Automated audits (the same checks behind this methodology) are being connected — the dimensions and scoring will not change.`)
};

const zh_directory_hubs_signals_faq_when_a = /** @type {(inputs: Directory_Hubs_Signals_Faq_When_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品页当前展示的是确定性的预览分。自动化审计（与本页方法论相同的检查项）正在接入——维度与计分方式不会改变。`)
};

/**
* | output |
* | --- |
* | "Product pages currently show deterministic preview scores. Automated audits (the same checks behind this methodology) are being connected — the dimensions an..." |
*
* @param {Directory_Hubs_Signals_Faq_When_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_faq_when_a = /** @type {((inputs?: Directory_Hubs_Signals_Faq_When_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Faq_When_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_faq_when_a(inputs)
	return zh_directory_hubs_signals_faq_when_a(inputs)
});
export { directory_hubs_signals_faq_when_a as "directory.hubs.signals.faq.when_a" }